import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/criteria/styles.scss';export default {
  "criteria": "_criteria_1g9oh_1",
  "header": "_header_1g9oh_7",
  "row": "_row_1g9oh_18",
  "icon": "_icon_1g9oh_26",
  "toggleIcon": "_toggleIcon_1g9oh_34",
  "name": "_name_1g9oh_43",
  "form": "_form_1g9oh_49",
  "open": "_open_1g9oh_53",
  "option": "_option_1g9oh_60"
};